(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gr8bake-blog-search-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gr8bake-blog-search')) {
    class Gr8bakeBlogSearch extends HTMLElement {
      constructor() {
        super();

        this.input = this.querySelector(
          '.gr8bake-blog-search__input'
        );

        this.clearButton = this.querySelector(
          '.gr8bake-blog-search__clear'
        );

        this.results = this.querySelector(
          '.gr8bake-blog-search__results'
        );

        this.status = this.querySelector(
          '.gr8bake-blog-search__status'
        );

        this.endpoint = this.dataset.endpoint;

        this.blogPath = (
          this.dataset.blogPath || ''
        ).replace(/\/$/, '');

        this.minimumCharacters = Number(
          this.dataset.minCharacters || 2
        );

        this.resultLimit = Number(
          this.dataset.resultLimit || 8
        );

        this.descriptionLimit = Number(
          this.dataset.descriptionLimit || 140
        );

        this.fallbackAuthor =
          this.dataset.fallbackAuthor || '';

        this.metaSeparator =
          this.dataset.metaSeparator || '·';

        this.abortController = null;
        this.debounceTimer = null;

        this.onInput = this.onInput.bind(this);
        this.onClear = this.onClear.bind(this);
        this.onDocumentClick =
          this.onDocumentClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        if (
          !this.input ||
          !this.results ||
          !this.endpoint
        ) {
          return;
        }

        this.input.addEventListener(
          'input',
          this.onInput
        );

        this.input.addEventListener(
          'keydown',
          this.onKeydown
        );

        this.clearButton?.addEventListener(
          'click',
          this.onClear
        );

        document.addEventListener(
          'click',
          this.onDocumentClick
        );
      }

      disconnectedCallback() {
        this.abortController?.abort();
        clearTimeout(this.debounceTimer);

        this.input?.removeEventListener(
          'input',
          this.onInput
        );

        this.input?.removeEventListener(
          'keydown',
          this.onKeydown
        );

        this.clearButton?.removeEventListener(
          'click',
          this.onClear
        );

        document.removeEventListener(
          'click',
          this.onDocumentClick
        );
      }

      onInput() {
        const query = this.input.value.trim();

        if (this.clearButton) {
          this.clearButton.hidden =
            query.length === 0;
        }

        clearTimeout(this.debounceTimer);
        this.abortController?.abort();

        if (
          query.length <
          this.minimumCharacters
        ) {
          this.closeResults();
          return;
        }

        this.debounceTimer = setTimeout(() => {
          this.search(query);
        }, 250);
      }

      onKeydown(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();

          const query = this.input.value.trim();

          if (
            query.length >=
            this.minimumCharacters
          ) {
            this.search(query);
          }

          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeResults();
          this.input.focus();
        }
      }

      async search(query) {
        this.abortController?.abort();

        this.abortController =
          new AbortController();

        this.renderMessage(
          'Searching guides…'
        );

        const url = new URL(
          this.endpoint,
          window.location.origin
        );

        url.searchParams.set('q', query);

        url.searchParams.set(
          'resources[type]',
          'article'
        );

        url.searchParams.set(
          'resources[limit]',
          '10'
        );

        try {
          const response = await fetch(
            url.toString(),
            {
              headers: {
                Accept: 'application/json'
              },
              signal:
                this.abortController.signal
            }
          );

          if (!response.ok) {
            throw new Error(
              `Search failed: ${response.status}`
            );
          }

          const data = await response.json();

          const articles =
            data?.resources?.results?.articles ||
            [];

          const matchingArticles = articles
            .filter((article) => {
              try {
                const articleUrl = new URL(
                  article.url,
                  window.location.origin
                );

                return articleUrl.pathname.startsWith(
                  `${this.blogPath}/`
                );
              } catch {
                return false;
              }
            })
            .slice(0, this.resultLimit);

          this.renderResults(
            matchingArticles,
            query
          );
        } catch (error) {
          if (
            error.name ===
            'AbortError'
          ) {
            return;
          }

          this.renderMessage(
            'Unable to load results. Please try again.'
          );

          this.status.textContent =
            'Unable to load blog search results.';
        }
      }

      stripHtml(html) {
        if (!html) {
          return '';
        }

        const temporaryElement =
          document.createElement('div');

        temporaryElement.innerHTML = html;

        return (
          temporaryElement.textContent || ''
        )
          .replace(/\s+/g, ' ')
          .trim();
      }

      truncateText(
        text,
        maximumLength
      ) {
        if (
          !text ||
          text.length <= maximumLength
        ) {
          return text;
        }

        const shortenedText =
          text.slice(0, maximumLength);

        const finalSpace =
          shortenedText.lastIndexOf(' ');

        const cleanText =
          finalSpace >
          maximumLength * 0.65
            ? shortenedText.slice(
                0,
                finalSpace
              )
            : shortenedText;

        return `${cleanText.trim()}…`;
      }

      formatPublishedDate(value) {
        if (!value) {
          return '';
        }

        const date = new Date(value);

        if (
          Number.isNaN(
            date.getTime()
          )
        ) {
          return '';
        }

        return new Intl.DateTimeFormat(
          document.documentElement.lang ||
            'en',
          {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
          }
        ).format(date);
      }

      getDescription(article) {
        const rawDescription =
          article.summary_html ||
          article.body ||
          article.description ||
          '';

        const cleanDescription =
          this.stripHtml(
            rawDescription
          );

        return this.truncateText(
          cleanDescription,
          this.descriptionLimit
        );
      }

      getAuthor(article) {
        if (
          typeof article.author ===
          'string'
        ) {
          return article.author.trim();
        }

        if (
          article.author &&
          typeof article.author.name ===
            'string'
        ) {
          return article.author.name.trim();
        }

        return this.fallbackAuthor.trim();
      }

      renderResults(
        articles,
        query
      ) {
        this.results.replaceChildren();

        if (!articles.length) {
          this.renderMessage(
            `No guides found for “${query}”.`
          );

          this.status.textContent =
            `No learning guides found for ${query}.`;

          return;
        }

        const fragment =
          document.createDocumentFragment();

        articles.forEach((article) => {
          const link =
            document.createElement('a');

          link.className =
            'gr8bake-blog-search__result';

          link.href = article.url;

          link.setAttribute(
            'role',
            'option'
          );

          if (article.image) {
            const image =
              document.createElement(
                'img'
              );

            image.className =
              'gr8bake-blog-search__result-image';

            image.src = article.image;
            image.alt = '';
            image.loading = 'lazy';
            image.width = 192;
            image.height = 144;

            link.appendChild(image);
          } else {
            const placeholder =
              document.createElement(
                'span'
              );

            placeholder.className =
              'gr8bake-blog-search__result-image';

            placeholder.setAttribute(
              'aria-hidden',
              'true'
            );

            link.appendChild(
              placeholder
            );
          }

          const content =
            document.createElement(
              'span'
            );

          content.className =
            'gr8bake-blog-search__result-content';

          const title =
            document.createElement(
              'span'
            );

          title.className =
            'gr8bake-blog-search__result-title';

          title.textContent =
            article.title;

          const descriptionText =
            this.getDescription(
              article
            );

          const description =
            document.createElement(
              'span'
            );

          description.className =
            'gr8bake-blog-search__result-description';

          description.textContent =
            descriptionText ||
            'Read this learning guide.';

          const author =
            this.getAuthor(article);

          const publishedDate =
            this.formatPublishedDate(
              article.published_at
            );

          const meta =
            document.createElement(
              'span'
            );

          meta.className =
            'gr8bake-blog-search__result-meta';

          if (
            author &&
            publishedDate
          ) {
            meta.textContent =
              `${author} ${this.metaSeparator} ${publishedDate}`;
          } else if (author) {
            meta.textContent =
              author;
          } else if (publishedDate) {
            meta.textContent =
              publishedDate;
          } else {
            meta.hidden = true;
          }

          content.append(
            title,
            description,
            meta
          );

          link.appendChild(content);
          fragment.appendChild(link);
        });

        this.results.appendChild(
          fragment
        );

        this.openResults();

        this.status.textContent =
          `${articles.length} learning guides found.`;
      }

      renderMessage(message) {
        this.results.replaceChildren();

        const paragraph =
          document.createElement('p');

        paragraph.className =
          'gr8bake-blog-search__message';

        paragraph.textContent =
          message;

        this.results.appendChild(
          paragraph
        );

        this.openResults();
      }

      openResults() {
        this.results.hidden = false;

        this.input.setAttribute(
          'aria-expanded',
          'true'
        );
      }

      closeResults() {
        this.results.hidden = true;

        this.input.setAttribute(
          'aria-expanded',
          'false'
        );

        this.status.textContent = '';
      }

      onClear() {
        this.abortController?.abort();
        clearTimeout(
          this.debounceTimer
        );

        this.input.value = '';

        if (this.clearButton) {
          this.clearButton.hidden =
            true;
        }

        this.closeResults();
        this.input.focus();
      }

      onDocumentClick(event) {
        if (
          !this.contains(
            event.target
          )
        ) {
          this.closeResults();
        }
      }
    }

    customElements.define(
      'gr8bake-blog-search',
      Gr8bakeBlogSearch
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr8bake-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class Gr8bakeProductTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-gr8bake-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-gr8bake-panel]'));
      this.viewAll = this.querySelector('[data-gr8bake-view-all]');
      this.viewAllLabel = this.viewAll?.querySelector('.gr8bake-product-tabs__view-all-label');

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleClick = (event) => {
      const tab = event.target.closest('[data-gr8bake-tab]');
      if (!tab || !this.contains(tab)) return;
      this.activate(tab, true);
    };

    handleKeydown = (event) => {
      const currentTab = event.target.closest('[data-gr8bake-tab]');
      if (!currentTab || !this.contains(currentTab)) return;

      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = null;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === null) return;

      event.preventDefault();
      this.activate(this.tabs[nextIndex], true);
    };

    handleBlockSelect = (event) => {
      const tab = this.querySelector(`[data-gr8bake-tab][data-shopify-editor-block*="${event.detail.blockId}"]`);
      if (tab) this.activate(tab, false);
    };

    activate(tab, moveFocus) {
      const targetPanelId = tab.dataset.panelId;

      this.tabs.forEach((item) => {
        const isActive = item === tab;
        item.setAttribute('aria-selected', String(isActive));
        item.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== targetPanelId;
      });

      if (this.viewAll) {
        this.viewAll.href = tab.dataset.collectionUrl || '#';

        if (this.viewAllLabel) {
          const prefix = this.viewAll.dataset.viewAllPrefix || 'Explore';
          const title = tab.dataset.tabLabel;
          this.viewAllLabel.textContent = title ? `${prefix} ${title}` : prefix;
        }
      }
      if (moveFocus) tab.focus();
    }
  }

  if (!customElements.get('gr8bake-product-tabs')) {
    customElements.define('gr8bake-product-tabs', Gr8bakeProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
